import DepositBankSettings from "@/models/Products/ProductSettings/DefaultSettings/Banking/DepositBankSettings";

export default class AccountDepositBankSettings extends DepositBankSettings {
    overridden: boolean = false;
}